import { createSlice } from '@reduxjs/toolkit';
import React from 'react';

interface WarningModalDialogState {
  isModalOpen: boolean;
  okLabel: string;
  header: string;
  description: React.ReactNode;
  onConfirm?: () => void;
}

export const initialState: WarningModalDialogState = {
  isModalOpen: false,
  okLabel: '',
  header: '',
  description: '',
};

export const warningModalDialog = createSlice({
  name: 'app/warningModalDialog',
  initialState,
  reducers: {
    openWarningModalDialog(state, payload: any) {
      state.isModalOpen = true;
      state.header = payload.payload.header;
      state.description = payload.payload.description;
      state.onConfirm = payload.payload.onConfirm;
      state.okLabel = payload.payload.okLabel;
    },
    closeWarningModalDialog(state) {
      state.isModalOpen = false;
    },
  },
});

export const warningActions = warningModalDialog.actions;

export const { openWarningModalDialog, closeWarningModalDialog } = warningModalDialog.actions;

export default warningModalDialog.reducer;

export const warningModalDialogState = (state: any) => state?.warningModalDialog;
